export enum NativePresentationMode {
  Root = 'root',
  Push = 'push',
  Modal = 'modal',
}

export interface MobileSettings {
  readonly presentationMode: NativePresentationMode;
  readonly safeAreaHeight: number;
  readonly bottomSafeAreaHeight: number;
}
